import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE } from 'store/system/actions';

const initialState = {
  normalized: {},
  paged: {
    items: [],
    totalCount: 0,
  },
  grouped: {
    items: [],
    totalCount: 0,
  },
};

const externalProgramMappingsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_EXTERNAL_PROGRAM_MAPPINGS:
        draft.normalized = payload;
        break;

      case EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_PAGED_PROGRAM_MAPPINGS:
        draft.paged.items = payload.items || [];
        draft.paged.totalCount = payload.totalCount || 0;
        break;

      case EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_GROUPED_PROGRAM_MAPPINGS:
        draft.grouped.items = payload.items || [];
        draft.grouped.totalCount = payload.totalCount || 0;
        break;

      case EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.CREATE_EXTERNAL_PROGRAM_MAPPING:
      case EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.UPDATE_EXTERNAL_PROGRAM_MAPPING:
        draft.normalized[payload.id] = payload;
        break;

      case EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.DELETE_EXTERNAL_PROGRAM_MAPPING:
        delete draft.normalized[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default externalProgramMappingsReducer;
